import { ISelfResponse, IUpdateSelfRequest } from '@/shared/interfaces';
import { atom } from 'jotai/index';

// Backing atom that holds the ISelfResponse we get from the server
export const selfResponseAtom = atom<ISelfResponse | null>();

// Derived atom that transforms ISelfResponse -> IUpdateSelfRequest
export const selfRequestAtom = atom((get) => {
    const response = get(selfResponseAtom);
    if (!response) return null;

    return {
        Name:
            response.Me.User.FullName === 'Pseudonym'
                ? ''
                : (response.Me.User.FullName ?? ''),
        Email: response.Me.Email ?? '',
        CPR: response.Me.CprValidated ? (response.Me.CPR ?? '') : '',
        Mobile: response.Me.MobilePhone ?? '',
    } as IUpdateSelfRequest;
});
